/* Ring details section (ring-spec-details F05).
   Redraws the plates written by snippets/beylora-ring-specs.liquid when the shopper picks a carat.
   The data is the beylora.ring_specs JSON in <script type="application/json" data-beylora-ring-specs>.
   With no such tag on the page this file does nothing. Text is set with textContent only.
   The markup built here must stay identical to the snippet's server render. */
(function () {
  'use strict';
  if (window.__beyRingSpecsLoaded) return;
  window.__beyRingSpecsLoaded = true;

  var SUB_DEFAULT = 'The small lab-grown diamonds';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }
  function has(v) { return v !== null && v !== undefined && String(v).trim() !== ''; }

  function row(label, value, small, valueClass) {
    var wrap = el('div', 'bey-rs-row');
    wrap.appendChild(el('dt', null, label));
    var dd = el('dd');
    if (valueClass) dd.appendChild(el('span', valueClass, value));
    else dd.appendChild(document.createTextNode(String(value)));
    if (small) dd.appendChild(el('small', null, small));
    wrap.appendChild(dd);
    return wrap;
  }

  function plate(title, sub, rows, note) {
    if (!rows.length) return null;
    var p = el('div', 'bey-rs-plate');
    var head = el('div', 'bey-rs-head');
    head.appendChild(el('p', 'bey-rs-title', title));
    if (sub) head.appendChild(el('p', 'bey-rs-sub', sub));
    p.appendChild(head);
    var dl = el('dl', 'bey-rs-rows');
    rows.forEach(function (r) { dl.appendChild(r); });
    p.appendChild(dl);
    if (note) p.appendChild(el('p', 'bey-rs-note', note));
    return p;
  }

  function build(specs, carat) {
    var out = [];
    var setting = specs.setting || {};
    var by = (specs.by_carat && Object.prototype.hasOwnProperty.call(specs.by_carat, carat)) ? specs.by_carat[carat] : null;
    by = by || {};
    var rows = [];
    if (has(setting.band_width)) rows.push(row('Band width', setting.band_width));
    if (has(setting.center_setting)) rows.push(row('Center setting', setting.center_setting));
    if (has(by.height)) rows.push(row('Setting height', by.height, 'Inside of the band to the top of the setting'));
    if (by.flush === true) rows.push(row('Wedding band', 'Sits flush', 'A straight band rests against it', 'bey-rs-yes'));
    else if (by.flush === false) rows.push(row('Wedding band', 'Leaves a small gap', 'A curved band fits closer'));
    var first = plate('Ring details', 'For the ' + carat + 'ct ring', rows);
    if (first) out.push(first);

    var groups = Array.isArray(specs.accent_groups) ? specs.accent_groups : [];
    groups.forEach(function (g, i) {
      if (!g) return;
      var n = (Array.isArray(by.groups) && by.groups[i]) || {};
      var r = [];
      if (has(g.shape)) r.push(row('Shape', g.shape));
      if (has(n.number)) r.push(row('Number', n.number));
      if (has(n.weight)) r.push(row('Minimum total weight', n.weight));
      if (has(g.setting_style)) r.push(row('Setting style', g.setting_style));
      if (has(g.avg_color)) r.push(row('Average color', g.avg_color));
      if (has(g.avg_clarity)) r.push(row('Average clarity', g.avg_clarity));
      var sub = has(g.type) ? 'The small ' + String(g.type).toLowerCase() + 's' : SUB_DEFAULT;
      var emerald = has(g.type) && String(g.type).toLowerCase() === 'lab-grown emerald';
      var p = plate(emerald ? 'Accent emeralds' : 'Accent diamonds', sub, r, 'Your center diamond is graded on its own IGI report.');
      if (p) out.push(p);
    });
    return out;
  }

  // The picked carat: the number on the selected choice, written like %g ("2", "1.5"), never the label.
  function pickedCarat() {
    var sel = document.querySelector('[data-beylora-carat-choice].is-selected');
    if (!sel) return null;
    var n = parseFloat(sel.getAttribute('data-carat'));
    if (!isFinite(n)) return null;
    return String(n);
  }

  function readSpecs(root) {
    var tag = root.querySelector('script[data-beylora-ring-specs]');
    if (!tag) return null;
    try {
      var data = JSON.parse(tag.textContent);
      return data && typeof data === 'object' ? data : null;
    } catch (e) { return null; }
  }

  function refresh() {
    var carat = pickedCarat();
    if (carat === null) return;
    var roots = document.querySelectorAll('[data-bey-rs]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-carat') === carat) continue;
      var specs = readSpecs(root);
      if (!specs) continue;
      var tag = root.querySelector('script[data-beylora-ring-specs]');
      var old = root.querySelectorAll('.bey-rs-plate');
      for (var j = 0; j < old.length; j++) old[j].parentNode.removeChild(old[j]);
      build(specs, carat).forEach(function (p) { root.insertBefore(p, tag); });
      root.setAttribute('data-carat', carat);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-beylora-carat-choice]')) setTimeout(refresh, 0);
  });
  document.addEventListener('variant:update', refresh);
  refresh();
})();
